import { Button, Icon, Text } from '@flatfile/baseline'
import React from 'react'
import { NewFlatfileLogoFull } from '../../../assets/new-flatfile-logo-full'

interface HeaderProps {
  showCloseButton?: boolean
}

export const Header: React.FC<HeaderProps> = ({ showCloseButton = true }) => {
  return (
    <div className='flex items-center justify-between border-b border-border-table-border bg-surface-base px-4 py-2 w-full top-0 h-fit'>
      <div className='flex-1 flex items-center justify-start'>
        <NewFlatfileLogoFull />
      </div>
      <div className='flex items-center gap-2 flex-1 justify-center'>
        <Icon name='cursor-click' size={16} />
        <Text variant='body' emphasized color='primary' className='tracking-wider text-sm'>
          Flatfile OS
        </Text>
      </div>
      <div className='flex-1 flex justify-end'>
        {showCloseButton && (
          <Button
            variant='secondary'
            icon='cross-large'
            iconPlacement='left'
            iconProps={{ size: 12 }}
            onClick={() => window.parent?.postMessage({ type: 'CLOSE_FLATFILE_OS' }, '*')}
          >
            Cancel
          </Button>
        )}
      </div>
    </div>
  )
}
